import { createProxyUrl } from '@/app/nuxt/config/proxy';
import { processAxiosInstance } from '@/plugins/axios';
import {
  apiRetry,
  EnvironmentType,
} from '@/shared/lib';

import type {
  Context,
  Plugin,
} from '@nuxt/types';
import type { NuxtAxiosInstance } from '@nuxtjs/axios';

let clientApiInstance: NuxtAxiosInstance | undefined;

const clientApiPlugin: Plugin = (ctx: Context) => {
  const {
    $axios,
    $config,
    req,
    $sentry,
  } = ctx;

  clientApiInstance = $axios;
  processAxiosInstance(clientApiInstance, req);

  let endpoint = '';

  if ($config.ENVIRONMENT === EnvironmentType.Local) {
    if (process.client) {
      endpoint = `${ location.origin }`;
    } else {
      endpoint = createProxyUrl($config.MAIN_SITE_HOST || 'staging.strana.itstrana.site', 'lk');
    }
  } else if (process.client) {
    endpoint = $config.CLIENT_API_URL;
  } else {
    endpoint = $config.SERVER_API_URL;
  }

  clientApiInstance.setBaseURL(endpoint);
  clientApiInstance.defaults.timeout = 45 * 1000;
  clientApiInstance.defaults.headers.platform = 'Broker'; // TODO: Нужен ли этот заголовок для запросов к бэку ЛК

  apiRetry(clientApiInstance, { retryCount: 5 });

  clientApiInstance.interceptors.response.use(
    (response) => {
      $sentry.addBreadcrumb({
        category: 'http',
        data: {
          url: response.config.url,
          method: response.config.method,
          request: response.config.data,
          response: response.data,
        },
      });

      return response;
    },
    (error) => {
      $sentry.captureException(error, {
        extra: {
          request: error.config?.data,
          response: error.response?.data,
        },
      });

      return Promise.reject(error);
    },
  );
};

export default clientApiPlugin;

export const useClientApi = (): NuxtAxiosInstance => {
  if (clientApiInstance == null) {
    throw new Error('Client API instance is not defined');
  }

  return clientApiInstance;
};
